<template>
	<div class="diagnosis-result-detail">
		<div class="detail-container">
			<div class="detail-content">
				<h3 class="moudleDefaultTitle">诊断结果</h3>

				<!-- 展示不同证书的资质诊断比对结果详情 -->
				<component :is="getResultDetailComponentBySslCode" :record-id="diagnosisRecordId"></component>
				<!-- <safety-permit-maintenance-diagnosis-result-detail
					:record-id="diagnosisRecordId"
				></safety-permit-maintenance-diagnosis-result-detail> -->
			</div>
		</div>
	</div>
</template>

<script>
	import SafetyPermitMaintenanceDiagnosisResultDetail from './comparisonDiagnostic/safetyPermitMaintenanceDiagnosisResultDetail'
	import ConstructionEnterpriseDiagnosisResultDetail from './comparisonDiagnostic/constructionEnterpriseDiagnosisResultDetail'
	import RealEstateDevelopmentDiagnosisResultDetail from './comparisonDiagnostic/realEstateDevelopmentDiagnosisResultDetail'
	import EngineeringSupervisionDiagnosisResultDetail from './comparisonDiagnostic/engineeringSupervisionDiagnosisResultDetail'

	// 诊断结果详情
	export default {
		name: 'DiagnosisResultDetail',
		components: {
			SafetyPermitMaintenanceDiagnosisResultDetail,
			ConstructionEnterpriseDiagnosisResultDetail,
			RealEstateDevelopmentDiagnosisResultDetail,
			EngineeringSupervisionDiagnosisResultDetail
		},
		props: {},
		data() {
			return {
				// 添加当前激活的tab索引
				activeTabIndex: 0,
				// 当前查看的证书类型编码
				ssl: '',
				// 诊断记录id
				diagnosisRecordId: '',
				// 诊断结果数据
				diagnosisData: []
			}
		},
		computed: {
			// 通过sslCode判断渲染那个证书的资质诊断比对结果详情
			getResultDetailComponentBySslCode() {
				// 组件映射表
				const componentMap = {
					// 建筑业
					'107': 'ConstructionEnterpriseDiagnosisResultDetail',
					// 安许
					'109': 'SafetyPermitMaintenanceDiagnosisResultDetail',
					// 工程监理
					'106': 'EngineeringSupervisionDiagnosisResultDetail',
					// 房地产开发
					'111': 'RealEstateDevelopmentDiagnosisResultDetail'
				}

				// 根据sslCode获取对应的组件名，不存在则返回默认组件
				return componentMap[this.ssl] || 'ConstructionEnterpriseDiagnosisResult'
			}
		},
		watch: {},
		created() {
			// 获取诊断记录对应的记录id和证书类别
			this.diagnosisRecordId = this.$route.query && this.$route.query.recordId
			this.ssl = this.$route.query && this.$route.query.ssl
		},
		mounted() {},

		methods: {}
	}
</script>

<style lang="scss" scoped>
	@import './styles/diagnosisTable.scss';

	.diagnosis-result-detail {
		.detail-container {
			background-color: #eaf2f7;
			padding: 20px 0;
			.detail-content {
				width: $main-page-width;
				margin: 0 auto;

				.detial-wrapper {
					margin-top: 10px;
					padding: 20px;
					background-color: #ffffff;
					box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
					border-radius: 6px;
				}
			}
		}
	}
</style>
